<div class="endpoints-list-page">
  <mat-card>
    <div class="header">
      <div class="title">Endpoints management</div>
    </div>
    <div class="endpoints-table" *ngIf="hasData()">
      <viavi-table
        [tableConfigurations]="table"
        (sendRowAction)="onActionClick($event)"
        (sendPopupAction)="sendPopupAction($event)"
      >
      </viavi-table>
    </div>
    <div class="no-results" *ngIf="!hasData() && !isLoading">No records found</div>
  </mat-card>
</div>
